export default "/images/sesec-title.webp"